import TwoColumnVideo from './TwoColumnVideo';

export default TwoColumnVideo;
